import MicroModal from 'micromodal';
import { closeSliderCart } from '../slider-cart';
import { initProductSwiperCarousel, destroyProductSwiperCarousel } from './products-carousel';
import { getSizedImageURL } from '../../core/images';

// Extract the products from the images sections
const getProductsModal = (slide_i, block_id, retry = false) => {
  let product_handles = [];
  const section_images = document.querySelectorAll(`[data-block-id="${block_id}"].gallery__row .gallery__image`);

  // Might happen if we try to load the next slide that doesn't exist
  if (!section_images[slide_i]) {
    return product_handles;
  }

  const slide_products = section_images[slide_i].querySelectorAll('.gallery__product a');

  slide_products.forEach(product_link => {
    const handle = product_link.getAttribute('data-product-handle');
    if (handle && handle.length) {
      product_handles.push(handle);
    }
  });

  // The following only works for 2 slides

  // Slide doesn't have products, use the previous ones
  if (!product_handles.length && slide_i > 0 && !retry) {
    product_handles = getProductsModal(slide_i - 1, block_id, true);
  }

  // Slide still doesn't have products, use the next ones
  if (!product_handles.length && !retry) {
    product_handles = getProductsModal(slide_i + 1, block_id, true);
  }

  // console.log('product_handles', product_handles);

  return product_handles;
};

const addLookbookCarousel = (block_id, selected_slide = 1) => {
  // Find the lookbook images
  const section_images = document.querySelectorAll(`[data-block-id="${block_id}"].gallery__row .gallery__image img`);
  const img_srcs = [];
  let bkg_img = false;

  section_images.forEach(section_image => {
    let src = section_image.getAttribute('data-shopify-src');
    src = (!src || !src.length) ? section_image.src : src;
    img_srcs.push(src);
  });

  // Images might be set as background images (three_items_v2 for instance)
  if (section_images.length === 0) {
    document.querySelectorAll(`[data-block-id="${block_id}"].gallery__row .gallery__image`).forEach(section_image => {
      img_srcs.push(section_image.getAttribute('data-image'));
    });
    bkg_img = true;
  }

  // console.log('img_srcs', img_srcs);

  const carouselItems = document.querySelector('[data-gallery-products-modal-carousel-items]');
  if (carouselItems) {
    carouselItems.innerHTML = '';
    carouselItems.classList.remove('swiper');
  }

  let slider_needed = false;
  if (img_srcs.length > 1) {
    slider_needed = true;
    if (carouselItems) {
      carouselItems.classList.add('swiper');
      carouselItems.innerHTML = `<div class="swiper-wrapper"></div>`;
    }
  }

  img_srcs.forEach(img_src => {
    let image_src = img_src;
    const image_w = 1800;

    if (!bkg_img) {
      // Image loaded from Imgix
      if (image_src.indexOf('?') !== -1 && image_src.indexOf('imgix') !== -1) {
        image_src = `${image_src.split('?')[0]}?auto=format&w=${image_w}`;
      } else {
        image_src = getSizedImageURL(image_src, `${image_w}x`, true);
      }
    }

    const wrapperSelector = slider_needed
      ? '[data-gallery-products-modal-carousel-items] .swiper-wrapper'
      : '[data-gallery-products-modal-carousel-items]';

    const wrapper = document.querySelector(wrapperSelector);
    if (wrapper) {
      wrapper.insertAdjacentHTML('beforeend', `
        <div class="gallery-products-carousel__item${slider_needed ? ' swiper-slide' : ''}" data-gallery-products-carousel-item>
          <div class="gallery-products-carousel__image">
            <img src="${image_src}" title="Shoppable image" alt="Shoppable image" />
          </div>
        </div>
      `);
    }
  });

  initProductSwiperCarousel('[data-gallery-products-modal-carousel-items]', selected_slide, block_id);

  // Add total items for css
  const modalItems = document.querySelector('[data-gallery-products-modal-items]');
  if (modalItems) {
    const total = document.querySelectorAll(`[data-block-id="${block_id}"] [data-products-carousel-json]`).length;
    modalItems.setAttribute('data-gallery-products-modal-items-total', total);
  }
};

const initProductsCarouselModal = () => {
  document.addEventListener('click', (e) => {
    const modalTrigger = e.target.closest('[data-modal="#shoppable-modal"]');
    if (!modalTrigger) return;

    document.documentElement.classList.add('modal--opened');

    closeSliderCart();

    MicroModal.show('shoppable-modal', {
      disableScroll: true,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
      onShow: () => {
        const block_id = modalTrigger.closest('.gallery__row').dataset.blockId;
        modalTrigger.classList.add('active');

        const current_scrolltop = window.scrollY;
        window.scrollTo({ top: current_scrolltop });

        const galleryModal = document.querySelector('[data-gallery-products-modal]');
        if (galleryModal) galleryModal.setAttribute('data-block-id', block_id);

        addLookbookCarousel(block_id, modalTrigger.parentElement.dataset.galleryItem);
      },
      onClose: () => {
        document.documentElement.classList.remove('modal--opened');

        destroyProductSwiperCarousel();

        const carouselItems = document.querySelector('[data-gallery-products-modal-carousel-items]');
        if (carouselItems) carouselItems.innerHTML = '';

        const modalItems = document.querySelector('[data-gallery-products-modal-items]');
        if (modalItems) modalItems.innerHTML = '';

        const galleryModal = document.querySelector('[data-gallery-products-modal]');
        if (galleryModal) galleryModal.setAttribute('data-block-id', '');

        modalTrigger.classList.remove('active');

        const current_scrolltop = window.scrollY;
        window.scrollTo({ top: current_scrolltop });
      }
    });
  });
};

// $(window).on('breakpointHasChanged', (e, current_breakpoint) => {
//   if ($('#shoppable-modal').is(':visible') && current_breakpoint === 'mobile') {
//     $('#shoppable-modal [rel="modal:close"]').trigger('click');
//   }
// });

export {
  initProductsCarouselModal,
  getProductsModal,
};
